import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '../store'
import { Screens } from 'patient-api-lib'

export const initialState = {}

export const done = createAsyncThunk<
  Screens,
  void,
  { dispatch: AppDispatch; state: RootState }
>('bookingSummary/done', async () => {
  return Screens.BookingContactScreen
})

export const BookingSummaryScreenSlice = createSlice({
  name: 'bookingSummaryScreen',
  initialState,
  reducers: {},
})

export default BookingSummaryScreenSlice.reducer
